import PropTypes from 'prop-types';
import React from 'react';

import Menu from '@99designs/react-components/components/Menu';
import MenuItemActionList from '@99designs/react-components/components/MenuItemActionList';
import AnchorMenuItemAction from '@99designs/react-components/components/AnchorMenuItemAction';

export default class BriefNavbar extends React.Component {
    constructor(props) {
        super(props);

        this.sectionSelectHandler = this.sectionSelectHandler.bind(this);
    }

    render() {
        return (
            <Menu variations={['compact']}>
                <MenuItemActionList>
                    {this.props.sections.map(section => {
                        return (
                            <AnchorMenuItemAction
                                url={'#section-' + section.key}
                                key={section.key}
                                isSelected={section.isSelected}
                                notification={section.notifications}
                                anchorProps={{
                                    onClick: this.sectionSelectHandler(section.key),
                                }}
                            >
                                {section.title}
                            </AnchorMenuItemAction>
                        );
                    })}
                </MenuItemActionList>
            </Menu>
        );
    }

    sectionSelectHandler(section) {
        return e => {
            e.preventDefault();
            window.history.pushState(null, window.document.title, `#${section}`);
            this.props.onSelectSection(section);
        };
    }
}

BriefNavbar.propTypes = {
    sections: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            title: PropTypes.node.isRequired,
            isSelected: PropTypes.bool.isRequired,
            notifications: PropTypes.number,
        })
    ).isRequired,
    onSelectSection: PropTypes.func,
};

BriefNavbar.defaultProps = {
    notifications: 0,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief-navbar.jsx